// import Vue from 'vue'
import store from "@/front/stores/front";
import ProductPageCommander from "@/components/features/ProductPageCommander"

document.addEventListener('DOMContentLoaded',  () => {
  new Vue({
    store,
    el: '#product-page-commander',
    render: h => h(ProductPageCommander)
  });
});

